import type { CrmContactsPayload } from '../api';
import { CONTACT_KEY } from '../repository';

const makeContactQueryKeyFromState = ({ Domain, FullName, CompanyName }: Partial<CrmContactsPayload>) => {
  return [CONTACT_KEY, Domain?.toLowerCase(), CompanyName?.toLowerCase(), FullName?.toLowerCase()];
};

const crmContactQueryKey = {
  fromState: makeContactQueryKeyFromState,
};

export default crmContactQueryKey;
